var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaiting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.375 7.75H11.625M25.8333 27.125H24.5417M24.5417 27.125H6.45834M24.5417 27.125C24.5417 23.8827 22.9758 20.8399 20.3374 18.9552L15.5 15.5M6.45834 27.125H5.16667M6.45834 27.125C6.45834 23.8827 8.0242 20.8399 10.6626 18.9552L15.5 15.5M15.5 15.5L20.3374 12.0447C22.9758 10.1601 24.5417 7.11737 24.5417 3.875M15.5 15.5L10.6626 12.0447C8.0242 10.1601 6.45834 7.11737 6.45834 3.875M25.8333 3.875H24.5417M24.5417 3.875H6.45834M6.45834 3.875H5.16667",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiting);
export default __webpack_public_path__ + "static/media/waiting.c0d4f8cd15ca9fc3ac94a3eca0ec5d60.svg";
export { ForwardRef as ReactComponent };